import {
  WithStyles,
  Theme,
  createStyles,
  withStyles,
  Dialog,
  DialogTitle,
  List,
  ListItem,
  ListItemAvatar,
  Avatar,
  ListItemText,
  Divider,
} from "@material-ui/core";
import * as React from "react";
import PersonIcon from "@material-ui/icons/Person";
import { colors, getMomentDate } from "../constants/constants";
const drawerWidth = 340;
const styles = (theme: Theme) =>
  createStyles({
    root: {
      height: "100%",
      padding: 3,
    },
    button: {
      margin: theme.spacing(1),
      width: "30%",
      height: 48,
    },
    paper: {
      padding: theme.spacing(1) * 2,
      textAlign: "center",
      height: "100%",
      color: theme.palette.text.secondary,
    },
    control: {
      padding: theme.spacing(1) * 2,
    },
    appBar: {
      [theme.breakpoints.up("sm")]: {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: drawerWidth,
      },
    },
    menuHideButton: {
      marginRight: theme.spacing(2),
      [theme.breakpoints.up("sm")]: {
        display: "none",
      },
    },
    menuShowButton: {
      marginRight: theme.spacing(2),
      [theme.breakpoints.up("sm")]: {
        display: "visible",
      },
      color: "black",
    },
    extendedIcon: {
      marginRight: theme.spacing(1),
    },
    sectionDesktop: {
      display: "none",
      [theme.breakpoints.up("md")]: {
        display: "flex",
      },
    },
    avatar: {
      backgroundColor: colors.primaryColor,
      color: "#ffff",
    },
    toolbar: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      paddingTop: 0,
      paddingBottom: 8,
      minHeight: 64,
    },
    drawerPaper: {
      width: drawerWidth,
    },
    content: {
      flexGrow: 1,
      padding: theme.spacing(3),
    },
    large: {
      margin: 10,
      width: theme.spacing(15),
      height: theme.spacing(15),
    },
  });
interface Props extends WithStyles<typeof styles> {
  open: any;
  dialogTitle: any;
  approvalsData: any;
  onClose: any;
}
class SignedByDialog extends React.Component<Props> {
  handleClose = () => {
    this.props.onClose();
  };

  handleListItemClick = () => {
    this.props.onClose();
  };

  render() {
    const { open, approvalsData, dialogTitle, classes } = this.props;
    return (
      <Dialog
        fullWidth
        onClose={() => this.handleClose()}
        aria-labelledby="simple-dialog-title"
        open={open}
      >
        <DialogTitle id="simple-dialog-title">{dialogTitle}</DialogTitle>
        <Divider />
        {approvalsData && (
          <List>
            {approvalsData.map((item: any, index: any) => (
              <ListItem key={index.toString()}>
                <ListItemAvatar>
                  <Avatar className={classes.avatar}>
                    <PersonIcon />
                  </Avatar>
                </ListItemAvatar>
                <ListItemText

                  primary={item.fullName}
                  secondary={`Employee Number: ${item.employeeNumber}`}
                />
                <ListItemText
                  style={{ textAlign: "end" }}
                  primary={"Signed On:"}
                  secondary={getMomentDate(item.signedOn)}
                />
              </ListItem>
            ))}
          </List>
        )}
      </Dialog>
    );
  }
}
export default withStyles(styles)(SignedByDialog);
